import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { HorizontalSeparator } from '@cld/separator';

export interface SectionWrapperProps {
  highlight?: boolean;
  showHorizontalLine?: boolean;
  children?: ReactNode;
}

const Root = styled.div<{highlight?: boolean}>`
  padding: ${globalTheme.spacing.xs} 0;

  ${(props) => props.highlight && css`
    background: ${globalTheme.palette.secondary};
  `};
`;

export const SectionWrapper: FC<SectionWrapperProps> = ({ highlight, showHorizontalLine = true, children }) => (
  <>
    <Root highlight={highlight}>
      {children}
    </Root>
    {showHorizontalLine && <HorizontalSeparator />}
  </>
);
